import type { GoogleMarketingPlatformState } from './GoogleMarketingPlatform.types';

export const INIT_STATE: GoogleMarketingPlatformState = {
  googleAccounts: [],
  adAccountStatuses: {},
  authenticationUrl: '',
  loading: false,
};
